
export const Header = () => {
    return (
        <>
        <h1 className="header-text">Expense Tracker</h1>
        </>
    )
}